import React from 'react';
import './Hourly.css';
export const WeatherIcons = {
  "01d": "icons/sunny.svg",
  "01n": "icons/night.svg",
  "02d": "icons/day.svg",
  "02n": "icons/cloudy-night.svg",
  "03d": "icons/cloudy.svg",
  "03n": "icons/cloudy.svg",
  "50n": "icons/cloudy.svg",
  "04d": "icons/perfect-day.svg",
  "04n": "icons/cloudy-night.svg",
  "09d": "icons/rain.svg",
  "09n": "icons/rain-night.svg",
  "10d": "icons/rain.svg",
  "50d": "icons/rain.svg",
  "10n": "icons/rain-night.svg",
  "11d": "icons/storm.svg",
  "11n": "icons/storm.svg",
  "50d": "icons/rain.svg",
};

function Hourly({data,icon}) {
 
  let settimes = function (timeNum) {
    var hour = new Array(47);
    var date = new Date();
    var hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
    var am_pm = date.getHours() >= 12 ? "pm" : "am";
    function nexthourampm(hour, ampm){
      let nexthour, nextampm;
      if (hour === 11) {
        nexthour = 12;
        if (ampm === "am") {
          nextampm = "pm";
        } else {
          nextampm = "am";
        }
      } else if (hour === 12) {
        nexthour = 1;
        if (ampm === "am") {
          nextampm = "am";
        } else {
          nextampm = "pm";
        }
      } else {
        nexthour = hour + 1;
        nextampm = ampm;
      }
      return [nexthour , nextampm];
    }

    hour[0] = nexthourampm(hours, am_pm);
    for (let i = 1; i < 48; i++) {
      hour[i] = nexthourampm(hour[i-1][0], hour[i-1][1])
    }
    return hour[timeNum];
  };
    return (
      <>
       <h3>🕛  HOURLY FORECAST</h3>
        <div className="Hourly">
           {data?.hourly?.map((x,key)=>(<div className="hourly__card">
             <div key={key} className="myhourly">
              <div>{settimes(key)}</div>
              <div>&nbsp;<img src={WeatherIcons[x.weather[0].icon]}></img></div>
              <div>{Math.round(x.temp)}&nbsp;°C</div>
            </div></div>))}
           
           
         
         
           
              {/* {console.log(data.hourly)} */}
        </div>
        </>
    );
}

export default Hourly;

